// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 10354); hand-edits allowed (see docs/architecture.md)

/** `this.PAPA_HOURS` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_PAPA_HOURS(): any {
  return [9, 16, 14, 20, 11, 17, 10, 13, 15, 21, 12, 19, 20, 18, 14, 20, 16, 9, 11, 13, 10, 17, 21, 12, 15, 18, 19, 17, 10, 14, 20, 16, 15, 13, 11, 21, 18, 12, 19, 10];
}
